<template>
  <div class="fullscrean text-muted">
    <div>
      <div><img src="../assets/logo-lecard.png" alt="Logo Lecard" style="width: 72px"></div>
      <div class="mt-2 mb-4">
        <h5 class="font-weight-bold">Em construção</h5>
        <p>Estamos trabalhando para entregar uma funcionalidade incrível para você.</p>
      </div>
      <div class="mt-4">
        <router-link :to="usuario.habilitar_comanda === '1' ? '/home' : '/pedidos'" class="btn btn-primary">Voltar para Home</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      usuario() {
        return this.$store.state.dataUser;
      }
    }
  }
</script>

<style scoped>
.fullscrean {
  display: flex;
  height: 96vh;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  width: 100%;
  text-align: center;
}

@media (max-height: 550px) {
  .fullscrean {
    height: auto;
    margin-top: 130px;
  }
}
</style>
